import styled from 'styled-components'

export const TR = styled.div`
  display: flex;
  align-items: baseline;
  padding: 1rem;
  min-height: 70px;
  transition: flex 0.3s ease-out;
`

export const TH = styled.div<{ active?: boolean }>`
  position: relative;
  flex: 1 1 20%;
  color: ${p => (p.active ? '#1E1E1E' : '#585D64')};
  font-size: 15px;
  font-weight: 600;
  padding: 0 0.5rem 0 0;

  svg {
    position: absolute;
    top: 0.5rem;
    margin-left: 0.5rem;
  }

  span {
    display: inline-block;
    line-height: 1.5rem;
  }
`

export const MainSection = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const Info = styled(MainSection)`
  flex-direction: column;
  align-items: flex-start;
`

export const Actions = styled.div`
  margin-left: auto;
  width: 2.5rem;
`
